export const WORKSPACE_BG_COLOR = '#ffffff';
export const BOARD_BG_COLOR = '#ffffff';
export const USER_BG_COLOR = '#ddd';